export interface IConfig {

    traveller: {
        show: boolean
    };

}

/**
 * Config Model
 * If we add fieldset we to define it here
 */
export class Config implements IConfig {

    public traveller = { show: true };

}
